import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-257164b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ss-tela-estrutura" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24 ant-col-xxl-24" }
const _hoisted_4 = { class: "ss-principais-acoes" }
const _hoisted_5 = { class: "ant-btn-group ss-grupo-recursos" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Gerar", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "ant-row" }
const _hoisted_9 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_10 = { class: "ant-row" }
const _hoisted_11 = { class: "ant-col ant-col-xs-24 ant-col-xl-10" }
const _hoisted_12 = { style: {"display":"flex","gap":"10px"} }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Novo Layout", -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_16 = {
  key: 0,
  class: "ant-col ant-col-xs-24 ant-col-xl-5"
}
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_18 = { class: "ant-row" }
const _hoisted_19 = {
  key: 0,
  class: "ant-col ant-col-xs-24 ant-col-xl-24"
}
const _hoisted_20 = {
  key: 1,
  class: "ant-col ant-col-xs-24 ant-col-xl-24"
}
const _hoisted_21 = {
  key: 2,
  class: "ant-col ant-col-xs-24 ant-col-xl-24"
}
const _hoisted_22 = { class: "ant-row" }
const _hoisted_23 = { class: "ant-col ant-col-xs-18 ant-col-xl-24" }
const _hoisted_24 = {
  class: "ant-row",
  style: {"max-height":"400px","overflow":"auto"}
}
const _hoisted_25 = { class: "ss-header-resizable" }
const _hoisted_26 = { class: "ss-header-title" }
const _hoisted_27 = ["onMousedown"]
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { key: 2 }
const _hoisted_31 = { key: 3 }
const _hoisted_32 = { class: "ant-row" }
const _hoisted_33 = { class: "ant-col ant-col-xs-12 ant-col-xl-12" }
const _hoisted_34 = {
  key: 0,
  class: "ant-col ant-col-xs-12 ant-col-xl-12"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_titulo_padrao = _resolveComponent("titulo-padrao")!
  const _component_selecionar_relatorio_painel_vendas = _resolveComponent("selecionar-relatorio-painel-vendas")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_filtro_periodo_movimento_comercial = _resolveComponent("selecionar-filtro-periodo-movimento-comercial")!
  const _component_selecionar_data_inicial_final = _resolveComponent("selecionar-data-inicial-final")!
  const _component_selecionar_tipo_filtro_relatorio_p_c_p = _resolveComponent("selecionar-tipo-filtro-relatorio-p-c-p")!
  const _component_selecionar_tipo_producao = _resolveComponent("selecionar-tipo-producao")!
  const _component_selecionar_engenharia_producao = _resolveComponent("selecionar-engenharia-producao")!
  const _component_selecionar_produto = _resolveComponent("selecionar-produto")!
  const _component_selecionar_campos_relatorio_p_c_p = _resolveComponent("selecionar-campos-relatorio-p-c-p")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_card = _resolveComponent("card")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_totalizador = _resolveComponent("totalizador")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_preview_pdf = _resolveComponent("preview-pdf")!
  const _component_criacao_edicao_layout_pcp_modal = _resolveComponent("criacao-edicao-layout-pcp-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_card, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_titulo_padrao, {
              identificadorRecurso: 'PAINEL_RELATORIO_PCP',
              tituloRecurso: _ctx.state.tituloRecurso,
              exibirAtalhosTela: false,
              exibirHistoricoTela: true,
              empresasSelecionadas: [_ctx.dadosEmpresa.codigoEmpresa]
            }, {
              BotoesAcoes: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("button", {
                      class: "ant-btn ant-btn-secondary ss-btn-recursos",
                      title: "Imprimir",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.PDF)))
                    }, [
                      _createVNode(_component_icone, { nome: "imprimir" })
                    ]),
                    _createElementVNode("button", {
                      class: "ant-btn ant-btn-secondary ss-btn-recursos",
                      title: "Exportar Excel",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.Excel)))
                    }, [
                      _createVNode(_component_icone, { nome: "excel" })
                    ]),
                    _createElementVNode("button", {
                      class: "ant-btn ant-btn-secondary ss-btn-recursos",
                      title: "Exportar CSV",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.CSV)))
                    }, [
                      _createVNode(_component_icone, { nome: "download-arquivo" })
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "ant-btn ant-btn-primary ss-btn-tela",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.buscarRelatorio && _ctx.buscarRelatorio(...args)))
                    }, _hoisted_7)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["tituloRecurso", "empresasSelecionadas"])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_a_collapse, {
              ghost: "",
              class: "ss-accordion",
              activeKey: _ctx.state.mostrarConfiguracao,
              "onUpdate:activeKey": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.mostrarConfiguracao) = $event)),
              style: {"display":"flex","flex-direction":"column"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_collapse_panel, {
                  key: "2",
                  header: "Filtros do Relatório"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_card, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form, { layout: "vertical" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("div", _hoisted_11, [
                                _createVNode(_component_a_form_item, {
                                  label: "Relatório",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_12, [
                                      _createVNode(_component_selecionar_relatorio_painel_vendas, {
                                        ref: "selectRelatorioRef",
                                        codigoSelecionado: _ctx.state.codigoRelatorio,
                                        "onUpdate:codigoSelecionado": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.codigoRelatorio) = $event)),
                                        descricaoSelecionado: _ctx.state.nomeRelatorio,
                                        "onUpdate:descricaoSelecionado": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.nomeRelatorio) = $event)),
                                        empresas: [_ctx.dadosEmpresa.codigoEmpresa],
                                        disabled: false,
                                        onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.obterDadosRelatorio())),
                                        onEditReport: _ctx.handleEditReport,
                                        onDeleteReport: _ctx.handleDeleteReport,
                                        modulo: 6,
                                        style: {"flex":"1"}
                                      }, null, 8, ["codigoSelecionado", "descricaoSelecionado", "empresas", "onEditReport", "onDeleteReport"]),
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "ant-btn ant-btn-primary ss-btn-tela",
                                        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.abrirModalConfiguracao && _ctx.abrirModalConfiguracao(...args)))
                                      }, _hoisted_14)
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_15, [
                                _createVNode(_component_a_form_item, {
                                  label: "Período",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_selecionar_filtro_periodo_movimento_comercial, {
                                      valor: _ctx.state.periodo,
                                      "onUpdate:valor": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.periodo) = $event)),
                                      onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.periodoAlterado()))
                                    }, null, 8, ["valor"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              (_ctx.state.periodo === _ctx.EFiltroPeriodoMovimentoComercial.Personalizado)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                    _createVNode(_component_a_form_item, {
                                      label: "Data Inicial e Final",
                                      class: "ss-margin-campos"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_selecionar_data_inicial_final, {
                                          dataInicialSelecionada: _ctx.state.dataInicialSelecionada,
                                          "onUpdate:dataInicialSelecionada": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.dataInicialSelecionada) = $event)),
                                          dataFinalSelecionada: _ctx.state.dataFinalSelecionada,
                                          "onUpdate:dataFinalSelecionada": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.dataFinalSelecionada) = $event)),
                                          onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.buscarRelatorio()))
                                        }, null, 8, ["dataInicialSelecionada", "dataFinalSelecionada"])
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_17, [
                                _createVNode(_component_a_form_item, {
                                  label: "Filtrar Por",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_selecionar_tipo_filtro_relatorio_p_c_p, {
                                      codigosSelecionados: _ctx.state.tiposFiltro,
                                      "onUpdate:codigosSelecionados": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.tiposFiltro) = $event))
                                    }, null, 8, ["codigosSelecionados"])
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_18, [
                              (_ctx.state.tiposFiltro.includes(1))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                    _createVNode(_component_a_form_item, {
                                      label: "Tipo de Produção",
                                      class: "ss-margin-campos"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_selecionar_tipo_producao, {
                                          varios: true,
                                          codigosSelecionados: _ctx.state.tiposProducao,
                                          "onUpdate:codigosSelecionados": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.tiposProducao) = $event)),
                                          disabled: false,
                                          empresas: [_ctx.dadosEmpresa.codigoEmpresa]
                                        }, null, 8, ["codigosSelecionados", "empresas"])
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.state.tiposFiltro.includes(2))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                    _createVNode(_component_a_form_item, {
                                      label: "Engenharia de Produto",
                                      class: "ss-margin-campos"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_selecionar_engenharia_producao, {
                                          varios: true,
                                          codigosSelecionados: _ctx.state.engenhariaProdutos,
                                          "onUpdate:codigosSelecionados": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.engenhariaProdutos) = $event)),
                                          disabled: false,
                                          empresas: [_ctx.dadosEmpresa.codigoEmpresa],
                                          tipoProducao: 0
                                        }, null, 8, ["codigosSelecionados", "empresas"])
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.state.tiposFiltro.includes(3))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                    _createVNode(_component_a_form_item, {
                                      label: "Matéria-Prima",
                                      class: "ss-margin-campos"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_selecionar_produto, {
                                          varios: true,
                                          codigosSelecionados: _ctx.state.materiasPrimas,
                                          "onUpdate:codigosSelecionados": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.materiasPrimas) = $event)),
                                          disabled: false,
                                          empresas: [_ctx.dadosEmpresa.codigoEmpresa]
                                        }, null, 8, ["codigosSelecionados", "empresas"])
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_22, [
                              _createElementVNode("div", _hoisted_23, [
                                _createVNode(_component_selecionar_campos_relatorio_p_c_p, {
                                  campos: _ctx.state.camposRelatorio,
                                  "onUpdate:campos": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.camposRelatorio) = $event))
                                }, null, 8, ["campos"])
                              ])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_collapse_panel, {
                  key: "3",
                  header: "Resultado"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_card, { class: "tabela-wrapper" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_24, [
                          _createVNode(_component_a_table, {
                            columns: _ctx.state.colunas.filter(item => item.visible),
                            "data-source": _ctx.state.dados.itens,
                            rowKey: "id",
                            pagination: false,
                            loading: _ctx.telaBase.carregando,
                            tableLayout: "fixed",
                            scroll: _ctx.state.telaMobile ? null : { x: 'max-content', y: _ctx.defineAlturaScrollDinamica(450) },
                            size: "small"
                          }, {
                            headerCell: _withCtx(({ column }) => [
                              _createElementVNode("div", _hoisted_25, [
                                _createElementVNode("span", _hoisted_26, _toDisplayString(column.title), 1),
                                _createElementVNode("span", {
                                  class: "ss-resize-handle",
                                  onMousedown: (e) => _ctx.iniciarResizeColuna(e, column)
                                }, null, 40, _hoisted_27)
                              ])
                            ]),
                            bodyCell: _withCtx(({ column, text }) => [
                              (column.customRenderRow === _ctx.ECustomRenderRow.MascararData)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(text)), 1))
                                : (column.customRenderRow === _ctx.ECustomRenderRow.MascararFracionado)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text)), 1))
                                  : (column.customRenderRow === _ctx.ECustomRenderRow.MascararPorcentagem)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text, 2) + "%"), 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(text), 1))
                            ]),
                            emptyText: _withCtx(() => [
                              _createVNode(_component_mensagem_sem_dados, {
                                resultadoPesquisa: !_ctx.telaBase.carregando,
                                mensagem: _ctx.telaBase.carregando
                          ? 'Buscando informações, por favor aguarde...'
                          : 'Nenhum registro foi encontrado com estes filtros!'
                              }, null, 8, ["resultadoPesquisa", "mensagem"])
                            ]),
                            _: 1
                          }, 8, ["columns", "data-source", "loading", "scroll"])
                        ]),
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("div", _hoisted_33, [
                            _createVNode(_component_totalizador, {
                              titulo: "QTD. REGISTROS",
                              valor: _ctx.state.dados.qtdRegistros,
                              casasDecimais: 0
                            }, null, 8, ["valor"])
                          ]),
                          (_ctx.mostrarTotalizadorQtdProduzir)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                _createVNode(_component_totalizador, {
                                  titulo: "QTD. A PRODUZIR",
                                  valor: _ctx.state.dados.qtdProduzirTotal,
                                  casasDecimais: 2
                                }, null, 8, ["valor"])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["activeKey"])
          ])
        ]),
        _createVNode(_component_preview_pdf, {
          arquivos: _ctx.state.arquivoPdf
        }, null, 8, ["arquivos"]),
        _createVNode(_component_criacao_edicao_layout_pcp_modal, {
          visible: _ctx.state.modalConfiguracaoVisivel,
          "onUpdate:visible": _cache[19] || (_cache[19] = ($event: any) => (_ctx.state.modalConfiguracaoVisivel = $event)),
          "modo-edicao": _ctx.state.modoEdicaoModal,
          "codigo-empresa": _ctx.dadosEmpresa.codigoEmpresa,
          "dados-cadastro-init": _ctx.state.dadosCadastro,
          "dados-relatorio-campos-init": _ctx.state.dadosRelatorioCampos,
          "tipo-producao-modal-init": _ctx.state.tipoProducaoModal,
          "engenharia-produtos-modal-init": _ctx.state.engenhariaProdutosModal,
          "materias-primas-modal-init": _ctx.state.materiasPrimasModal,
          onSalvar: _ctx.handleSalvarLayout
        }, null, 8, ["visible", "modo-edicao", "codigo-empresa", "dados-cadastro-init", "dados-relatorio-campos-init", "tipo-producao-modal-init", "engenharia-produtos-modal-init", "materias-primas-modal-init", "onSalvar"])
      ]),
      _: 1
    })
  ]))
}